import { render, staticRenderFns } from "./PrintPosFaNotVisible.vue?vue&type=template&id=1b2e7609&scoped=true"
import script from "./PrintPosFaNotVisible.vue?vue&type=script&lang=js"
export * from "./PrintPosFaNotVisible.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFaNotVisible.vue?vue&type=style&index=0&id=1b2e7609&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2e7609",
  null
  
)

export default component.exports